import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CenteredProgress, NoContainersMessage } from '../../components';
import { fetchBaseData } from '../../redux/baseData';
import { selectContainers, selectIsBaseDataFetch } from '../../selectors';

interface baseDataLoaderProps {
  children: JSX.Element;
}

export const BaseDataLoader = ({ children }: baseDataLoaderProps) => {
  const dispatch = useDispatch();
  const containers = useSelector(selectContainers);
  const isBaseDataFetch = useSelector(selectIsBaseDataFetch);

  useEffect(() => {
    if (!isBaseDataFetch) {
      dispatch(fetchBaseData());
    }
  }, [isBaseDataFetch, dispatch]);

  if (!isBaseDataFetch) {
    return <CenteredProgress />;
  }

  return containers.length > 0 ? children : <NoContainersMessage />;
};
